// Router assembly — lazy routes + role-based guard (doc 04 §8.4).
import { createRouter, createWebHistory } from 'vue-router'
import './types' // route meta augmentation
import { publicRoutes } from './routes/public.routes'
import { authRoutes } from './routes/auth.routes'
import { appRoutes } from './routes/app.routes'
import { adminRoutes } from './routes/admin.routes'
import { roleGuard } from './guards/role.guard'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    ...publicRoutes,
    ...authRoutes,
    ...appRoutes,
    ...adminRoutes,
    {
      path: '/403',
      name: 'forbidden',
      component: () => import('@/pages/errors/ForbiddenPage.vue'),
      meta: { layout: 'blank', public: true, title: 'Forbidden' },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/pages/errors/NotFoundPage.vue'),
      meta: { layout: 'blank', public: true, title: 'Not Found' },
    },
  ],
})

// auth + role + permission gates.
router.beforeEach(roleGuard)

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · CPA` : 'CPA'
})

export default router
